import { Button, EmptyState, EmptyStateActions, EmptyStateTitle } from '@customerio/pluma-components/react';

type RelationshipsEmptyStateProps = {
  canAddRelationships: boolean;
  onAddRelationships: () => void;
};

export function RelationshipsEmptyState({ canAddRelationships, onAddRelationships }: RelationshipsEmptyStateProps) {
  return (
    <EmptyState>
      <EmptyStateTitle icon="person">No relationships</EmptyStateTitle>
      <EmptyStateActions>
        <Button
          variant="primary"
          isDisabled={!canAddRelationships}
          onClick={onAddRelationships}
          data-test-add-relationships-button
        >
          Add relationships
        </Button>
      </EmptyStateActions>
    </EmptyState>
  );
}
